import React from 'react';

import styles from '../berryChat.module.scss';

interface CartCompleteCardProps {
  total: number;
  location?: string | null;
  onCheckout: () => void;
  checkoutLoading?: boolean;
}

const CartCompleteCard: React.FC<CartCompleteCardProps> = ({
  total,
  location,
  onCheckout,
  checkoutLoading,
}) => {
  const label = [location, `$${total.toFixed(2)}`].filter(Boolean).join(' · ');

  return (
    <div className={styles.cartCompleteCard}>
      <span className={styles.cartCompleteInfo}>🛒 {label}</span>
      <button
        className={styles.checkoutButton}
        onClick={onCheckout}
        disabled={checkoutLoading}
      >
        {checkoutLoading ? 'Loading…' : 'Proceed to Checkout'}
      </button>
    </div>
  );
};

export default CartCompleteCard;
